<template>
    <VModalWrapper :name="name" :title="title" v-on="listeners" v-bind="attributes">
        <ValidationObserver v-slot="{ handleSubmit }" v-if="itemId">
            <form class="active-form" @submit.prevent="handleSubmit(submit)">
                <p class="inventory-action-modal__hint">
                    Оборудование перейдёт в статус «В ремонте».
                    <template v-if="holderName">
                        Ответственный остаётся прежним — <strong>{{ holderName }}</strong
                        >.
                    </template>
                </p>

                <!-- ОПИСАНИЕ ОБЯЗАТЕЛЬНО, в отличие от комментариев у остальных операций:
                     через месяц вопрос «а что с ней было» задают обязательно, и пустая
                     строка превращает историю ремонтов в список дат. -->
                <ValidationProvider
                    class="active-form__field"
                    name="repair-comment"
                    rules="required"
                    v-slot="{ errors }"
                >
                    <label class="active-form__label active-form__label_required" for="repair-comment">
                        Что случилось
                    </label>

                    <VInput
                        id="repair-comment"
                        name="repair-comment"
                        class="active-form__control"
                        placeholder="Например: не включается, гремит вентилятор"
                        :class="{ error: errors[0] }"
                        :disabled="isSaving"
                        v-model="comment"
                    ></VInput>

                    <span class="active-form__error">{{ errors[0] }}</span>
                </ValidationProvider>

                <!-- Подрядчика здесь не выбирают: подходящего справочника в системе нет,
                     а справочник держателей описывает держателей ТЕХНИКИ, не сервисы.
                     Пока название сервиса пишут в это же поле. -->
                <p class="active-form__error inventory-action-modal__error" v-if="error">{{ error }}</p>

                <div class="active-form__actions">
                    <VButton
                        type="button"
                        class="active-form__action button_green-light"
                        :disabled="isSaving"
                        @click="hide"
                    >
                        Отмена
                    </VButton>

                    <VButton type="submit" class="active-form__action button_green" :disabled="isSaving">
                        {{ isSaving ? 'Сохраняем…' : 'Отправить в ремонт' }}
                    </VButton>
                </div>
            </form>
        </ValidationObserver>
    </VModalWrapper>
</template>
<script>
// Components
import VInput from '../../../components/VInput/VInput.vue';
import VButton from '../../../components/VButton/VButton.vue';
import VModalWrapper from '../../../components/VModalWrapper/VModalWrapper.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

// Other
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import ModalNames from '../../../../js/enums/ModalNames';
import ModalMixin from '../../../../js/vue/mixins/ModalMixin';
import { sendInventoryItemToRepair } from '../../../../js/inventory-api';
import { errorMessage } from '../../../../js/error';

/**
 * Отправка оборудования в ремонт (7-F2B).
 *
 * ОДНО ПОЛЕ, И ОНО ОБЯЗАТЕЛЬНО. Ремонт — единственное состояние, из которого вещь
 * не возвращается сама, и «что с ней было» спрашивают всегда.
 *
 * Держатель не меняется, и окно об этом говорит прямо: иначе кладовщик решит, что после
 * отправки в сервис технику придётся выдавать заново.
 *
 * Запрос делает окно: отказ сервера показывается здесь же, вместе с введённым текстом.
 */
@Component({
    components: {
        VInput,
        VButton,
        VModalWrapper,

        ValidationObserver,
        ValidationProvider,
    },
})
class VInventoryItemRepairModal extends ModalMixin {
    @Prop({ type: String, default: ModalNames.INVENTORY_ITEM_REPAIR })
    name;
    @Prop({ type: String, default: 'Отправка в ремонт' })
    defaultTitle;

    itemId = null;
    holderName = '';
    comment = '';
    error = '';
    isSaving = false;

    async submit() {
        if (this.isSaving || !this.itemId) {
            return;
        }

        this.isSaving = true;
        this.error = '';

        try {
            const response = await sendInventoryItemToRepair(this.itemId, { comment: this.comment });

            this.resolve(response.data);
            this.hide();
        } catch (requestError) {
            this.error = errorMessage(requestError);
        } finally {
            this.isSaving = false;
        }
    }

    beforeOpen(event) {
        const params = event?.params ?? {};

        this.itemId = params.itemId ?? null;
        this.holderName = params.holderName || '';
        this.comment = '';
        this.error = '';
        this.isSaving = false;
    }

    beforeClose() {
        this.itemId = null;
        this.comment = '';
        this.error = '';
    }
}

export default VInventoryItemRepairModal;
</script>
